import TeFrame from './index.vue';


TeFrame.install = function(Vue) {
  Vue.component(TeFrame.name, TeFrame);
};

export default TeFrame;